import { useTranslation } from 'react-i18next';

export default function FinalCTA() {
  const { t } = useTranslation();

  return (
    <section className="py-12 md:py-16 bg-white">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-stone-800 mb-3">
            {t('final_cta_h2')}
          </h2>
          <p className="text-sm md:text-base text-stone-600 leading-relaxed mb-6 md:mb-8">
            {t('final_cta_text')}
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-6 py-3 bg-emerald-600 text-white font-medium rounded-lg hover:bg-emerald-700 transition-colors text-sm md:text-base whitespace-nowrap"
            >
              {t('final_cta_primary')}
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-6 py-3 bg-stone-100 text-stone-700 font-medium rounded-lg hover:bg-stone-200 transition-colors text-sm md:text-base whitespace-nowrap"
            >
              {t('final_cta_secondary')}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}